import type { OrganizerProfileVisibilityResponse } from '@/src/listings/types/organizerProfileVisibility';
import { releaseFetchWithOverrideRecovery } from '@/lib/release/pageSourceOverride';

export const fetchOrganizerProfileVisibility = async (
  organizerId: string,
): Promise<OrganizerProfileVisibilityResponse> => {
  const url = `/e/api/organizer/${encodeURIComponent(organizerId)}/profile`;
  const response = await releaseFetchWithOverrideRecovery(url);

  if (!response.ok) {
    throw new Error(`Organizer profile request failed: ${response.status}`);
  }

  const payload = (await response.json()) as OrganizerProfileVisibilityResponse;
  return {
    hideAttendeeCount: payload?.hideAttendeeCount === true,
    hideTotalEvents: payload?.hideTotalEvents === true,
  };
};
